export const environment = {
  production: true,
  cms_host: 'https://api.allstarcasino.com',
  api_host: 'https://api.allstarcasino.com/api',
  app_host: 'https://www.allstarcasino.com',
  assets_host: 'https://media.allstarcasino.com',
  error_host: 'https://error.allstarcasino.com/error/handle',
  mlh_host: 'https://mlh.allstarcasino.com',
  redirector_host: 'https://api.dstat.site/api',
  wr_websocket: 'https://ue.gmngeng.com',
  platform_graphql: 'https://platform.allstarcasino.com/api/graphql',
  platform_brandId: '0c1a2e63-843a-494e-938c-cb9fc63a1ef4',
  zendesk_host: 'https://zendesk.dstat.site',
};

export enum BannerType {
  TOP_SLIDER = 20,
  TOP_SLIDER_FIAT = 25,
  BOTTOM_SLIDER = 6,
  BOTTOM_STICKY = 7,
  CONTINUOUS_CREEPING_LINES = 14,
  CREEPING_LINES_BY_TIME = 13,
  TOP_FEATURE = 21,
  REGISTER_BANNER = 22,
  REGISTER_BANNER_FIAT = 26,
  MOBILE_APP = 27,
}

export enum BlogType {
  TEXT = '1',
  VIDEO = '2',
}

export enum StaticContentType {
  LOYALTY_STATUSES = 20,
  BUY_CRYPTO = 22,
}

export enum KycRequestEnum {
  GENERAL_KYC = 'General_KYC',
  PAYMENT_KYC = 'Payment_KYC',
  ADDITIONAL_KYC = 'Additional_KYC',
  CREDIT_CARD_KYC = 'Credit Card KYC',
  BANK_TRANSFER_KYC = 'Bank Transfer KYC',
  E_WALLET_KYC = 'E_Wallet KYC',
}
